import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MsalService } from '@azure/msal-angular';
import { LoginService } from './services/login.service';
import { NaviComponent } from './components/navi/navi.component';
import { FooterComponent } from './components/footer/footer.component';

import { UserService } from './services/user.service';
import { MsalAuthService } from './services/msal-auth.service';
import { environment } from './environments/environment';
import { FlopFooterComponent } from './components/flopfooter/flopfooter.component';

declare let dataLayer: any;

@Component({
	standalone: true,
	selector: 'app-root',
	templateUrl: "./app.component.html",
	styleUrls: ['./app.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [
    RouterModule,
    NgbModule,
    NaviComponent,
    FooterComponent,
    FlopFooterComponent
]
})
export class AppComponent implements OnInit {
	title = 'LunaFulfillment';
	currentRoute: string = '';
	private _isLoginPage: boolean = true;

	constructor(
		private router: Router,
		private msalService: MsalService,
		private userService: UserService,
		private loginService: LoginService,
		private msalAuthService: MsalAuthService
	) {
		this.currentRoute = this.router.url.split('?')[0].substring(1);
		this.updateIsLoginPage();
	}

	public get isLoggedIn(): boolean {
		return this.userService.isLoggedIn;
	}

	public get isLoginPage(): boolean {
		return this._isLoginPage;
	}

	public get is404Page(): boolean {
		const definedRoutes = ['', 'forgotpassword', 'privacy', 'faq', 'toc', 'resetpassword', 'redirect', 'admin', 'styleguide', 'tools'];
		const currentRoute = window.location.pathname.substring(1) || '';
		const isDefinedRoute = definedRoutes.some(route => {
			if (route === '') {
				return currentRoute === '';
			}
			return currentRoute === route || currentRoute.startsWith(route + '/');
		});

		const isAdminRoute = currentRoute === 'admin' || currentRoute.startsWith('admin/');

		return !isDefinedRoute && !isAdminRoute && currentRoute !== '';
	}

	private updateIsLoginPage(): void {
		const loginRoutes = ['', 'forgotpassword', 'privacy', 'faq', 'toc', 'resetpassword', 'redirect'];
		const currentRoute = window.location.pathname.substring(1) || '';
		this._isLoginPage = loginRoutes.includes(currentRoute);
	}

	public get userInfo() {
		return this.userService.userInfo;
	}

	async ngOnInit() {
		await this.initializeMsalAndHandleRedirect();

		this.router.events.pipe(
			filter(event => event instanceof NavigationEnd)
		).subscribe((event: NavigationEnd) => {
			this.currentRoute = window.location.pathname.substring(1) || '';
			this.updateIsLoginPage();

			dataLayer.push({
				event: 'pageview',
				pagePath: event.urlAfterRedirects
			});
		});
	}

	private async initializeMsalAndHandleRedirect() {

		await this.msalService.initialize();
		await new Promise(resolve => setTimeout(resolve, 100));

		await this.msalAuthService.initialize();

		await this.msalService.instance.handleRedirectPromise();

		const activeAccount = this.msalService.instance.getActiveAccount();
		if (activeAccount) {
			await this.loadUserInfo();
		}

	}

	private async loadUserInfo() {

		const activeAccount = this.msalService.instance.getActiveAccount();

		if (activeAccount) {
			const tokenResponse = await this.msalService.instance.acquireTokenSilent({
				scopes: [environment.azureClient],
				account: activeAccount
			});

			if (tokenResponse.accessToken) {
				this.loginService.getInfo(tokenResponse.accessToken).subscribe({
					next: (claims) => {
						this.userService.setUserInfo(claims);
					}
				});
			}
		}


	}
}
